import { LoadableAfterPaint } from '@confluence/loadable';

export const UnarchivePagesDialogLoader = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-UnarchivePagesLoader" */ '../src/UnarchivePagesLoader.tsx'
			)
		).UnarchivePagesLoader,
});
